export default __webpack_public_path__ + "static/media/27938162.33e30d90.jpg";